// extracted by mini-css-extract-plugin
module.exports = {"divider":"HeaderDivider_divider__ydjaY"};